<p-button
  icon='pi pi-user'
  styleClass='p-button-lg p-button-rounded'
  (click)='menu.toggle($event)'
>
</p-button>

<p-menu [popup]='true' [model]='menuItems' #menu></p-menu>
<app-feedback-modal [(visible)]='modalOpen'></app-feedback-modal>
